
import React, { useEffect } from "react";
import HomePage from "./home.jsx";
import WhyChooseUS from "../WhyChooseUsPage";
import IndustriesWeServePage from "../TechnologiesWeOffer/index.js";
import BookaConsulationCallAction from "../BookConsulationPage";
import IndustriesWeServe from "../weServeInIndustries/index.js";
import Quote01Page from "../QuotePage01/index.jsx";
import OurKeyFeatures from "../OurProcess/index.js";
import TechnologiesWeWorkOn from "../TechLangugaesWeoffer/index.jsx";
import GetHaveAnyIdea from "../GethaveIdeaQoute02";
import ModeOfCommunication from "../ModeOfCommunicationPage";
import Portfolio from "../OurPortfolioPage";
import Testimonial from "../TestimonialPage";
import AboutUs from "../Aboutus";
import Contact from "../ContactPage";
import OurPromise from '../ourPromises'
import Footer from "../FooterPage";

// import ContactForm from '../forms/contactForm.jsx';
// import HeroSection from "../SbgImage/HeroSection.jsx"

// Scroll to section when URL hash changes (e.g., /#services)
import { useLocation } from "react-router-dom";

const ScrollToHashSection = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const el = document.getElementById(sectionId);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100); // Delay ensures DOM is ready
      }
    }
  }, [location]);

  return null;
};

const Home = () => {
  return (
    <>
      <ScrollToHashSection />

      <section id="home">
        <HomePage />
      </section>

      <section id="bookaConsulationCallAction">
        <BookaConsulationCallAction />
      </section>

      <section id="industriesWeServePage">
        <IndustriesWeServePage />
      </section>
       <section id="technologiesWeWorkOn">
        <TechnologiesWeWorkOn />
      </section>

      <section id="getHaveAnyIdea">
        <GetHaveAnyIdea />
      </section>

      <section id="industriesWeServe">
        <IndustriesWeServe />
      </section>
      
      <section id="quote01Page">
        <Quote01Page />
      </section>
      
      <section id="ourKeyFeatures">
        <OurKeyFeatures />
      </section>
      
      <section id="modeOfCommunication">
        <ModeOfCommunication />
      </section>

      {/* <section id="portfolio">
        <Portfolio />
      </section> */}

      <section id="testimonial">
        <Testimonial />
      </section>

      <section id="whyChooseUS">
        <WhyChooseUS />
      </section>

   <section id="ourPromises">
        <OurPromise/>
      </section>
      
      <section id="contact">
        <Contact />
      </section>


      <section id="footer">
        <Footer />
      </section>

      {/*----------------- Background canvas S-------------- */}
      {/* <section id="HeroSection">
        <HeroSection />
      </section> */}

      {/* <section id="contactForm">
        <ContactForm />
      </section> */}

      {/* <ModeOfCommunication />
      <Testimonial />
      <Footer /> */}
    </>
  );
};

export default Home;
